module.exports = __webpack_public_path__ + "static/gallery20-aee39ee6d36f06df88e7a2c66eb1f68f.jpg";